var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 231.817,
    height: 177.251,
    viewBox: "0 0 231.817 177.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8391",
    "data-name": "Grupo 8391",
    transform: "translate(-1.99 -0.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5776",
    "data-name": "Trazado 5776",
    d: "M354.367,144.124c-.21.153-.4.3-.608.446a20.48,20.48,0,0,1-2.373,1.447c-4.311,2.273-9.625,3.383-14.8,4.137-11.609,1.693-23.461,2.021-35.263,2.344-31.888.876-63.854,1.749-95.665-.268-12.568-.8-25.413-2.128-36.8-6.213q-2.449-.876-4.8-1.931a39.431,39.431,0,0,1-8.756-5.237,19.065,19.065,0,0,1-5.467-6.716c-2.407-5.287-1.133-11.226,1.615-16.408A50.985,50.985,0,0,1,155.3,109.7c2.122-2.918,4.462-5.752,6.6-8.668,7.6-10.365,12.552-23.478,5.541-34.109-2.015-3.054-4.927-5.735-6.569-8.924-2.095-4.078-1.933-8.607-1.267-13.006q.13-.838.274-1.659c1.137-6.523,3.278-13.551,9.879-17.623,6.856-4.231,16.592-4.018,25.1-2.514,13.232,2.363,25.438,7.281,37.774,11.722s25.242,8.5,38.8,8.934c11.971.385,25.935-2.5,33.88-10,7.717-7.281,22.223-7.836,32.678-3.437,7.177,3.019,12.531,8.456,14.789,14.573a19.022,19.022,0,0,1,.982,3.8,17.5,17.5,0,0,1,.176,3.58c-.031.591-.092,1.175-.176,1.753-1.747,12.07-14.322,21.59-21.965,32.372-3.735,5.266-6.372,11.592-3.8,17.271,3.917,8.653,17.539,11.731,25.765,18.17a19.356,19.356,0,0,1,4.043,4.148C361.784,131.813,360.312,139.553,354.367,144.124Z",
    transform: "translate(-126.224 -22.07)",
    fill: "#006384",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "flowers",
    transform: "translate(-0.01 -0.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5777",
    "data-name": "Trazado 5777",
    d: "M135.176,190.7S125.54,173.621,111.02,168.7a29.7,29.7,0,0,1-15.049-11.257,49.855,49.855,0,0,1-4.441-7.985",
    transform: "translate(-81.132 -122.643)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5778",
    "data-name": "Trazado 5778",
    d: "M43.157,107.342c1.655,1.6,9.359,3.274,9.359,3.274s-1.885-7.65-3.544-9.257a4.175,4.175,0,1,0-5.815,5.991Z",
    transform: "translate(-39.89 -81.686)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5779",
    "data-name": "Trazado 5779",
    d: "M56.055,169.253c2.26.448,9.636-2.344,9.636-2.344s-5.75-5.4-8.012-5.844a4.174,4.174,0,1,0-1.624,8.189Z",
    transform: "translate(-49.429 -129.754)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5780",
    "data-name": "Trazado 5780",
    d: "M123.086,241.519c2.179-.754,7.122-6.885,7.122-6.885s-7.684-1.757-9.86-1a4.175,4.175,0,1,0,2.723,7.889Z",
    transform: "translate(-101.592 -189.034)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5781",
    "data-name": "Trazado 5781",
    d: "M195.676,281.977c2.275-.377,8.19-5.582,8.19-5.582s-7.275-3.031-9.55-2.656a4.175,4.175,0,1,0,1.359,8.239Z",
    transform: "translate(-159.624 -220.864)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5782",
    "data-name": "Trazado 5782",
    d: "M113.884,144.638c0,2.3-4.169,8.993-4.169,8.993s-4.177-6.684-4.179-8.989a4.175,4.175,0,1,1,8.348,0Z",
    transform: "translate(-89.203 -113.46)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5783",
    "data-name": "Trazado 5783",
    d: "M195.438,190.113c-.689,2.2-6.67,7.332-6.67,7.332s-1.986-7.635-1.305-9.845a4.175,4.175,0,0,1,7.96,2.495Z",
    transform: "translate(-156.857 -150.614)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5784",
    "data-name": "Trazado 5784",
    d: "M266.635,250.694c-.306,2.285-5.333,8.354-5.333,8.354s-3.247-7.181-2.933-9.466a4.175,4.175,0,1,1,8.275,1.112Z",
    transform: "translate(-213.006 -198.931)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5788",
    "data-name": "Trazado 5788",
    d: "M195.676,281.977c2.275-.377,8.19-5.582,8.19-5.582s-7.275-3.031-9.55-2.656a4.175,4.175,0,1,0,1.359,8.239Z",
    transform: "translate(-159.624 -220.864)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5790",
    "data-name": "Trazado 5790",
    d: "M195.438,190.113c-.689,2.2-6.67,7.332-6.67,7.332s-1.986-7.635-1.305-9.845a4.175,4.175,0,0,1,7.96,2.495Z",
    transform: "translate(-156.857 -150.614)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5791",
    "data-name": "Trazado 5791",
    d: "M266.635,250.694c-.306,2.285-5.333,8.354-5.333,8.354s-3.247-7.181-2.933-9.466a4.175,4.175,0,1,1,8.275,1.112Z",
    transform: "translate(-213.006 -198.931)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5792",
    "data-name": "Trazado 5792",
    d: "M209.729,135.661s-1.885-19.519-13.172-29.9a29.691,29.691,0,0,1-9.2-16.389,49.887,49.887,0,0,1-.821-9.1",
    transform: "translate(-156.239 -67.947)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5793",
    "data-name": "Trazado 5793",
    d: "M151.621,27.18c.863,2.139,7.233,6.779,7.233,6.779s1.372-7.761.511-9.9a4.178,4.178,0,0,0-7.751,3.121Z",
    transform: "translate(-127.39 -18.441)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5794",
    "data-name": "Trazado 5794",
    d: "M138.323,89.041c1.885,1.326,9.755,1.76,9.755,1.76s-3.052-7.26-4.937-8.586a4.178,4.178,0,0,0-4.818,6.827Z",
    transform: "translate(-116.724 -66.879)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5796",
    "data-name": "Trazado 5796",
    d: "M220.351,248.6c2.233.578,9.751-1.785,9.751-1.785s-5.423-5.719-7.654-6.3a4.175,4.175,0,1,0-2.095,8.082Z",
    transform: "translate(-180.497 -194.523)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5797",
    "data-name": "Trazado 5797",
    d: "M200.987,90.291c-.932,2.107-7.455,6.529-7.455,6.529s-1.11-7.8-.178-9.91a4.175,4.175,0,1,1,7.634,3.381Z",
    transform: "translate(-160.331 -71.232)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5798",
    "data-name": "Trazado 5798",
    d: "M250.778,163.969c-1.521,1.732-9.068,4-9.068,4s1.274-7.776,2.8-9.508a4.173,4.173,0,1,1,6.272,5.507Z",
    transform: "translate(-199.853 -128.638)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5799",
    "data-name": "Trazado 5799",
    d: "M295.82,248.786c-1.207,1.965-8.262,5.476-8.262,5.476s-.059-7.88,1.148-9.845a4.178,4.178,0,1,1,7.122,4.37Z",
    transform: "translate(-236.097 -196.133)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_916",
    "data-name": "Elipse 916",
    cx: 72.363,
    cy: 3.042,
    rx: 72.363,
    ry: 3.042,
    transform: "translate(54.128 171.311)",
    fill: "#006384",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "floor_flowers",
    "data-name": "floor flowers",
    transform: "translate(37.608 147.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5810",
    "data-name": "Trazado 5810",
    d: "M682.07,836.173s-13.648-.823-12.038,8.742a2.327,2.327,0,0,0,1.211,2.457s.026-.707,1.4-.468a6.242,6.242,0,0,0,1.482.071,3.066,3.066,0,0,0,1.814-.749h0s3.835-1.582,5.326-7.854c0,0,1.1-1.369,1.062-1.721l-2.3.968a4.131,4.131,0,0,1,.168,3.044s-.074-2.983-.516-2.905c-.09,0-1.2.575-1.2.575s1.356,2.905.323,5c0,0,.387-3.551-.755-4.787l-1.614.946s1.582,2.989.51,5.43c0,0,.274-3.741-.849-5.2l-1.469,1.146s1.485,2.947.578,4.971c0,0-.116-4.355-.9-4.684a8.449,8.449,0,0,0-1.482,1.614s1.017,2.137.387,3.267c0,0-.387-2.905-.707-2.905a9.59,9.59,0,0,0-1.414,3.228,7.029,7.029,0,0,1,1.1-3.425,3.855,3.855,0,0,0-1.959,1.017s.2-1.359,2.26-1.479a8.837,8.837,0,0,1,1.343-1.546,8.406,8.406,0,0,0-3.319.381s1.1-1.291,3.7-.7l1.449-1.181a11.91,11.91,0,0,0-3.874.039s1.33-1.136,4.264-.323l1.582-.943a14.407,14.407,0,0,0-3.7-.323s1.459-.788,4.164.065l1.13-.507s-1.7-.323-2.2-.384-.523-.19-.523-.19a5.893,5.893,0,0,1,3.193.355A14.376,14.376,0,0,0,682.07,836.173Z",
    transform: "translate(-562.438 -823.27)",
    fill: "#4eb0b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5811",
    "data-name": "Trazado 5811",
    d: "M619.15,837.769s-7.7-.465-6.779,4.929a1.317,1.317,0,0,0,.684,1.385s0-.4.791-.265a3.76,3.76,0,0,0,.833.042,1.765,1.765,0,0,0,1.023-.423h0s2.163-.894,3.005-4.429c0,0,.62-.771.6-.969l-1.291.552a2.34,2.34,0,0,1,.094,1.717s-.042-1.682-.291-1.643c-.052,0-.675.323-.675.323a3.83,3.83,0,0,1,.187,2.818s.216-2.011-.426-2.7l-.914.536a4.041,4.041,0,0,1,.287,3.06s.155-2.111-.481-2.931l-.826.646a3.944,3.944,0,0,1,.323,2.8s-.068-2.457-.507-2.641a5.045,5.045,0,0,0-.836.9s.575,1.207.219,1.843c0,0-.219-1.637-.4-1.643a5.424,5.424,0,0,0-.8,1.827,3.922,3.922,0,0,1,.62-1.937,2.17,2.17,0,0,0-1.1.571s.113-.768,1.291-.833a4.892,4.892,0,0,1,.755-.872,4.728,4.728,0,0,0-1.872.213,2.1,2.1,0,0,1,2.085-.394l.817-.668a6.729,6.729,0,0,0-2.182.023,2.636,2.636,0,0,1,2.405-.174l.888-.53a7.976,7.976,0,0,0-2.085-.181,3.209,3.209,0,0,1,2.347.036l.646-.284s-.968-.19-1.236-.219-.3-.107-.3-.107a3.332,3.332,0,0,1,1.8.2A7.609,7.609,0,0,0,619.15,837.769Z",
    transform: "translate(-523.428 -824.357)",
    fill: "#4eb0b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5812",
    "data-name": "Trazado 5812",
    d: "M661.525,802.354s-9.287-.562-8.193,5.949a1.588,1.588,0,0,0,.826,1.672s0-.481.952-.323a4.576,4.576,0,0,0,1.007.049,2.127,2.127,0,0,0,1.236-.51h0s2.612-1.078,3.625-5.349c0,0,.752-.93.723-1.169l-1.569.668a2.822,2.822,0,0,1,.116,2.073s-.052-2.031-.355-1.982c-.058,0-.813.391-.813.391s.923,1.972.226,3.4c0,0,.264-2.428-.513-3.26l-1.1.646a4.873,4.873,0,0,1,.349,3.7s.187-2.547-.581-3.551l-1,.778s1.014,2,.4,3.383c0,0-.081-2.963-.613-3.19a6.088,6.088,0,0,0-1.007,1.088s.694,1.456.261,2.224c0,0-.261-1.972-.478-1.982a6.475,6.475,0,0,0-.968,2.2,4.749,4.749,0,0,1,.749-2.331,2.625,2.625,0,0,0-1.333.691s.136-.926,1.55-1.007a6.064,6.064,0,0,1,.914-1.052,5.748,5.748,0,0,0-2.26.261,2.533,2.533,0,0,1,2.518-.478l.988-.8a8.123,8.123,0,0,0-2.637.026s.9-.771,2.905-.21l1.075-.646A10.594,10.594,0,0,0,656,803.5a3.865,3.865,0,0,1,2.834.042l.768-.342s-1.159-.229-1.5-.265-.355-.129-.355-.129a4.013,4.013,0,0,1,2.173.242A9.447,9.447,0,0,0,661.525,802.354Z",
    transform: "translate(-551.157 -800.373)",
    fill: "#4eb0b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "browser",
    transform: "translate(28.638 19.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5813",
    "data-name": "Trazado 5813",
    d: "M377.933,219.46V117H178.65v96.582a39.675,39.675,0,0,0,8.8,5.379q2.359,1.087,4.818,1.988h183.29Z",
    transform: "translate(-178.65 -117)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5814",
    "data-name": "Trazado 5814",
    d: "M379.192,230.569V131H180.73v93.865a40.077,40.077,0,0,0,8.756,5.237q2.35,1.047,4.8,1.931H376.818Z",
    transform: "translate(-180.294 -128.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6087",
    "data-name": "Rect\\xE1ngulo 6087",
    width: 198.46,
    height: 5.266,
    transform: "translate(0.438 0.291)",
    fill: "#5a5773"
  })), /*#__PURE__*/React.createElement("g", {
    id: "buttons",
    transform: "translate(31.677 21.561)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_921",
    "data-name": "Elipse 921",
    cx: 1.362,
    cy: 1.362,
    r: 1.362,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_922",
    "data-name": "Elipse 922",
    cx: 1.362,
    cy: 1.362,
    r: 1.362,
    transform: "translate(3.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_923",
    "data-name": "Elipse 923",
    cx: 1.362,
    cy: 1.362,
    r: 1.362,
    transform: "translate(7.332)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boxes",
    transform: "translate(34.4 37.129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6088",
    "data-name": "Rect\\xE1ngulo 6088",
    width: 33.783,
    height: 20.6,
    transform: "translate(44.391)",
    fill: "#9a99a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6089",
    "data-name": "Rect\\xE1ngulo 6089",
    width: 32.783,
    height: 20.6,
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6090",
    "data-name": "Rect\\xE1ngulo 6090",
    width: 32.783,
    height: 20.6,
    transform: "translate(90.782)",
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6091",
    "data-name": "Rect\\xE1ngulo 6091",
    width: 32.783,
    height: 20.6,
    transform: "translate(0 29.45)",
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6092",
    "data-name": "Rect\\xE1ngulo 6092",
    width: 32.783,
    height: 20.6,
    transform: "translate(45.391 29.45)",
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6093",
    "data-name": "Rect\\xE1ngulo 6093",
    width: 32.783,
    height: 20.6,
    transform: "translate(90.782 29.45)",
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6094",
    "data-name": "Rect\\xE1ngulo 6094",
    width: 32.783,
    height: 20.6,
    transform: "translate(0 58.898)",
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6095",
    "data-name": "Rect\\xE1ngulo 6095",
    width: 32.783,
    height: 20.6,
    transform: "translate(45.391 58.898)",
    fill: "#5a5773",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6096",
    "data-name": "Rect\\xE1ngulo 6096",
    width: 32.783,
    height: 20.6,
    transform: "translate(90.782 58.898)",
    fill: "#5a5773",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "woman",
    transform: "translate(72.177 42.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5815",
    "data-name": "Trazado 5815",
    d: "M421.036,269.812s-5.888-10.763-4.9-12.514a23.849,23.849,0,0,0,1.724-4.286s2.174-1.487,2.174-2.095,1.722-2.013,2.629-2.625.452-3.5,0-3.85a7.982,7.982,0,0,1-1.171-1.575s.628-1.749,0-2.275.092-1.047,0-1.575a21.139,21.139,0,0,1,0-2.449,3.947,3.947,0,0,0-2.317-1.676l-.067-.277-.388-1.632s1.885-3.613-1.173-5.5a5.113,5.113,0,0,0-.677-.356,2.352,2.352,0,0,0-.017-.237,14.807,14.807,0,0,0-.444-2.767c-.159-.507-.367-.848-.628-.771a.419.419,0,0,0-.172.1,1.913,1.913,0,0,0-.325.383h0a.088.088,0,0,1-.015.023,6.569,6.569,0,0,0-.721,2,11.561,11.561,0,0,0-.209,1.257h0a6.911,6.911,0,0,0-.35.777c-.371.961-.8,2.627-.015,3.859.67,1.047,1.573,2.486,2.229,3.534l.021.034.04.065-.069.044v.161l.061.882.507,7.621a3.237,3.237,0,0,0-.465-.1,4.225,4.225,0,0,0-.677-.044c-.442-1.737-1.655-3.352-1.885-5.166a4.787,4.787,0,0,1-.036-.547c.019-1.142.3-2.287.281-3.427,0-.209,0-.419-.021-.628h0a1.68,1.68,0,0,0-.017-.174,5.151,5.151,0,0,0-2.8-3.9c-.526-.262-1.1-.436-1.607-.723-1.181-.662-1.938-1.856-3.01-2.675a3.332,3.332,0,0,0-2.88-.628,13.292,13.292,0,0,0-1.4.289h0a12.642,12.642,0,0,0-3.207,1.332c-.136.082-.272.165-.4.262a1.772,1.772,0,0,0-.647.756,1.982,1.982,0,0,0-.1.815c0,.2,0,.4.013.6-.059,3.352-3.67,5.945-3.967,9.217,0,.078-.013.155-.017.233v.358h0v.262c.052,1.435.8,2.771.934,4.2.013.128.019.253.021.381a6.335,6.335,0,0,1-.371,1.923,5.629,5.629,0,0,0-1.3.528,8.105,8.105,0,0,0-3.8,4.257,6.235,6.235,0,0,0-.274,1.869,39.018,39.018,0,0,1-.612,6.672,12.476,12.476,0,0,1-.385,1.64.385.385,0,0,0-.013.161l-.436,5.656-.078.995L387.5,269.9s.031.086.078.23a6.666,6.666,0,0,1,.172.654,3.514,3.514,0,0,1,.057,1.466,1.01,1.01,0,0,1-.306.538.226.226,0,0,0-.036.04,4.351,4.351,0,0,0-.331,1.441c-.038.293-.073.628-.109.976-.209,2.231-.339,5.57-.419,8.331-.075,2.723-.1,4.874-.1,4.874a5.559,5.559,0,0,0,1.125.557c-.029.073-.061.149-.09.228a11,11,0,0,0-.683,2.878,5.019,5.019,0,0,0,3.272,5.524,4.625,4.625,0,0,0,.563.193,1.787,1.787,0,0,0,1.433-.088c0,.124.015.243.021.362.029.511.054.978.067,1.37.09,2.451.7,6.737.7,6.737a8.919,8.919,0,0,1,.027,2.275,12.354,12.354,0,0,0,0,2.625s.628,1.047,0,1.575-.815,3.142-.628,3.5a.117.117,0,0,1,.01.04c.138.869-.643,13.785-.643,13.785s-.739,1.977-1.328,4.03c-.574,2-1.005,4.068-.473,4.456a4.446,4.446,0,0,0,1.657.448c0,.086-.013.172-.021.26a7.466,7.466,0,0,1-.367,2.17,25.332,25.332,0,0,0-.639,4.608l-.013.165a15.435,15.435,0,0,0-.674,1.956s-2,5.027-1.326,6.332a1.07,1.07,0,0,0,.249.308h0a.568.568,0,0,0,.065.059c.966.773,3.385.934,4.263.97l-.034,1.244v.046h1.142v-.031c0-.157.025-.878.063-1.841,0-.172.013-.352.021-.536,0-.145.015-.291.021-.442a7.75,7.75,0,0,0,.5-2.8,12.268,12.268,0,0,1,.44-3.243,9.007,9.007,0,0,1,.58-1.582,7.22,7.22,0,0,0-.14-3.22,2.324,2.324,0,0,0-.419-.725v-.419a12.084,12.084,0,0,1,.268-2.685.291.291,0,0,1,0-.042c.017-.073.036-.142.054-.209l.013-.046.371.013c1.137.031,1.973.031,1.973.031a42.563,42.563,0,0,0,.817-6.649v-.272a25.9,25.9,0,0,1,.549-4.715l.731-7.091a3.729,3.729,0,0,1,0-2.095c.224-.54.687-1.544,1.01-2.235.151-.321.27-.572.32-.681l.029-.059a1.356,1.356,0,0,1-.323-.161h0c-.3-.2-.559-.582.325-1.15,1.359-.876.907-3.063.907-3.063a1.572,1.572,0,0,1,.071-1.487c.471-.7,0-3.324,0-3.324a10.989,10.989,0,0,0,.93-2.189c.337-1.047,1.19-6.169,1.592-8.639.132-.811.209-1.334.209-1.334l.013.128.013.138h0l.113,1.167.015.155.209,2.206a67.9,67.9,0,0,1,.157,8.071v.042a2.687,2.687,0,0,1-.153.689c-.482,1.089-.394,5.417-.369,6.374v.193a3.855,3.855,0,0,0-.256,1.479h0a.949.949,0,0,0,.165.44,1.114,1.114,0,0,1,.161.681v.021a2.484,2.484,0,0,1-.025.3,5.755,5.755,0,0,1-.318,1.186,4.34,4.34,0,0,0-.3,1.946h0a.616.616,0,0,0,.119.237.56.56,0,0,1,.069.251.088.088,0,0,0,0,.023c.17,1.41-.268,7.633-.528,11.039-.1,1.345-.18,2.25-.18,2.25l-.719,7.436.071.05c.082.059.235.159.44.281v.017l-.031.224c-.1.716-.241,1.55-.392,2.187-.013.048-.023.094-.036.138a2,2,0,0,0-.769.308c-1.525,2.708-.85,4.856,0,5.48a2.2,2.2,0,0,1,.513,1.28l.209,2.7v.31a.8.8,0,0,0,.04.247l.065.819.088,1.14h.7V354.4h.038c1.1.038,2.868.084,3.639.023h.021a1.352,1.352,0,0,0,.209-.023.522.522,0,0,0,.122-.033c.408-.2,1.427-3.083.509-3.739a4.234,4.234,0,0,1-1.121-2.514c-.08-.243-.159-.473-.241-.693v-.142a11.524,11.524,0,0,1,.109-2.4,18.259,18.259,0,0,0,.239-2.868v-.266a3.577,3.577,0,0,0,.467-.153l.034-.015a3.292,3.292,0,0,0,.781-.463l2.564-11.362.27-1.322,1.54-7.518s-.543-2.625,0-3.06c.2-.159.253-.838.241-1.623-.021-1.374-.241-3.1-.241-3.1s.725-1.137,1.089-1.837a5.707,5.707,0,0,0,0-2.537l.714-4.206a39.752,39.752,0,0,1,2.809-9.188c1.466-3.09.532-11.433-.419-15.874-.025-.115-.05-.228-.075-.337v-.017c.448-.222,1-.49,1.584-.771l.222-.1c.744-.35,1.531-.71,2.237-1.01l.046-.019a15.63,15.63,0,0,1,1.556-.582,2.614,2.614,0,0,1,.478-.1C424.842,276.461,421.036,269.812,421.036,269.812Zm-28.344,14.234h.377c-.044.082-.086.165-.128.249-.025.05-.05.1-.073.149-.138.287-.266.58-.371.867.042-.31.094-.647.153-1.008C392.665,284.224,392.68,284.13,392.692,284.046Zm-1.018,5.461a.157.157,0,0,0,0-.029l-.031-.1c-.023-.067-.044-.134-.065-.209q.195-.059.4-.132H392v.069c-.01.1-.023.2-.036.293h0a.2.2,0,0,1,0,.038,2.041,2.041,0,0,1-.027.23c-.019.151-.038.3-.055.438-.04-.132-.08-.262-.122-.39A1,1,0,0,1,391.674,289.507Z",
    transform: "translate(-386.5 -223.338)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5816",
    "data-name": "Trazado 5816",
    d: "M519.663,237.834l-2.262.8-.821-1.362c-.628-1.047-1.5-2.48-2.143-3.521-1.135-1.831.35-4.621.35-4.621s.268-2.8,1.223-3.664,1.221,3.664,1.221,3.664c3.835,1.743,1.781,5.842,1.781,5.842l.373,1.626Z",
    transform: "translate(-487.299 -224.935)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5817",
    "data-name": "Trazado 5817",
    d: "M529.363,279.971l-2.262.8-.821-1.362v-.119a3.94,3.94,0,0,1,2.809-.555Z",
    transform: "translate(-497 -267.071)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5818",
    "data-name": "Trazado 5818",
    d: "M523.56,290.13l1.133-.959-.568-8.635a3.587,3.587,0,0,1,5.1,1.133,22.027,22.027,0,0,0,0,2.442c.088.524-.61,1.047,0,1.569s0,2.269,0,2.269a7.877,7.877,0,0,0,1.125,1.569c.436.348.874,3.228,0,3.838s-2.512,2.007-2.512,2.616-2.095,2.095-2.095,2.095l-1.839-2.432Z",
    transform: "translate(-494.85 -268.055)",
    fill: "#4eb0b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5819",
    "data-name": "Trazado 5819",
    d: "M394.567,536.955c-4.227-1.793-3.289-6.173-2.493-8.379a11.4,11.4,0,0,1,.559-1.307L395,525.83s.484,1.234,1,2.889C397.206,532.569,398.587,538.662,394.567,536.955Z",
    transform: "translate(-390.365 -462.466)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5820",
    "data-name": "Trazado 5820",
    d: "M413.414,765.455a7.124,7.124,0,0,0-.628,1.764,12.736,12.736,0,0,0-.272,3c.017.7.075,1.154.075,1.154l-4.709,3.238s.027-.379.073-.936a26.129,26.129,0,0,1,.614-4.592,7.645,7.645,0,0,0,.354-2.162c.073-.922.1-1.73.1-1.73S414.69,763.069,413.414,765.455Z",
    transform: "translate(-403.401 -651)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5821",
    "data-name": "Trazado 5821",
    d: "M469.977,779.215s0,.9-.033,1.948a19.954,19.954,0,0,1-.228,2.859,11.776,11.776,0,0,0-.107,2.392c.031,1.047.107,1.99.107,1.99s-4.807-4.546-4.317-4.906a2.227,2.227,0,0,0,.381-1c.147-.628.279-1.466.377-2.179.117-.848.191-1.531.191-1.531Z",
    transform: "translate(-448.843 -662.437)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5822",
    "data-name": "Trazado 5822",
    d: "M417.383,765.455a7.122,7.122,0,0,0-.628,1.764,38.514,38.514,0,0,1-3.854-.3c.071-.9.1-1.73.1-1.73S418.658,763.069,417.383,765.455Z",
    transform: "translate(-407.37 -651)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5823",
    "data-name": "Trazado 5823",
    d: "M472.971,779.231s0,.9-.034,1.948a5.241,5.241,0,0,1-3.787-.838c.117-.848.191-1.531.191-1.531Z",
    transform: "translate(-451.837 -662.453)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5824",
    "data-name": "Trazado 5824",
    d: "M431.535,497.508a40.684,40.684,0,0,0-2.7,9.158l-.7,4.189a5.9,5.9,0,0,1,0,2.528c-.35.7-1.047,1.833-1.047,1.833s.524,4.273,0,4.709,0,3.052,0,3.052l-1.745,8.8L422.9,543.112c-2.354,1.921-5.488-.522-5.488-.522l.691-7.413s1.047-12.987.612-13.519.174-2.181.174-2.181.612-1.571.176-2.181.086-1.919.086-1.919-.174-5.321.35-6.542,0-8.775,0-8.775l-.209-2.352-.121-1.3-.01-.128s-.08.522-.209,1.33c-.385,2.461-1.207,7.562-1.531,8.612a11.215,11.215,0,0,1-.894,2.181s.453,2.616,0,3.314a1.622,1.622,0,0,0-.069,1.483s.436,2.181-.874,3.052,0,1.309,0,1.309-.959,2.095-1.307,2.964a3.878,3.878,0,0,0,0,2.095l-.7,7.063a25.548,25.548,0,0,0-.524,4.971,43.684,43.684,0,0,1-.786,6.628s-6.716,0-7.751-.786,1.728-8.448,1.728-8.448.786-13.431.61-13.779,0-2.966.612-3.488,0-1.571,0-1.571a12.862,12.862,0,0,1,0-2.616,9.283,9.283,0,0,0-.027-2.269s-.584-4.273-.67-6.716-.524-7.935-.524-7.935.457-3.4.526-5.015a5.7,5.7,0,0,1,.628-2.038,18.193,18.193,0,0,1,1.3-2.279s20.665-6.108,21.532-5.5a7.894,7.894,0,0,1,.9,2.843C432.046,486.113,432.947,494.429,431.535,497.508Z",
    transform: "translate(-400.558 -425.285)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_924",
    "data-name": "Elipse 924",
    cx: 6.018,
    cy: 6.018,
    r: 6.018,
    transform: "translate(12.227 6.882)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5825",
    "data-name": "Trazado 5825",
    d: "M442.869,481.686c-.693.356-1.158.6-1.158.6s-9.768,4.623-12.545,4.361c-2.149-.209-7.635-.09-10.025-.031a18.19,18.19,0,0,1,1.3-2.279s20.667-6.106,21.534-5.5A7.935,7.935,0,0,1,442.869,481.686Z",
    transform: "translate(-412.303 -425.285)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5826",
    "data-name": "Trazado 5826",
    d: "M409.133,325s-5.574.88-6.89,1.743-3.921,2.53-3.921,6.106a34.643,34.643,0,0,1-.959,8.285c-.35,1.045,5.494,9.506,5.494,9.506l-2.095,12.822s8.379-.262,11.169,0,12.554-4.361,12.554-4.361,5.756-3.052,6.978-3.142-2.442-6.716-2.442-6.716-5.67-10.725-4.711-12.47a24.1,24.1,0,0,0,1.663-4.273l-1.047-8.894a3.422,3.422,0,0,0-2.878.436c-1.309.959-5.756.436-5.756.436Z",
    transform: "translate(-395.076 -302.486)",
    fill: "#4eb0b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5827",
    "data-name": "Trazado 5827",
    d: "M394.282,388.616l-2.187.61-.605,8.207s.786,2.181,0,2.878-.959,15.612-.959,15.612a5.7,5.7,0,0,0,5.495.436s-.436-1.657.874-7.675a47.958,47.958,0,0,0,1.307-9.07s0-7.5.612-8.723,0-4.273,0-4.273-1.221-1.657-1.135-2.267S394.282,388.616,394.282,388.616Z",
    transform: "translate(-389.686 -350.581)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5828",
    "data-name": "Trazado 5828",
    d: "M398.592,528.749a5.57,5.57,0,0,1-3.932-.142,11.4,11.4,0,0,1,.559-1.307l2.371-1.439S398.083,527.094,398.592,528.749Z",
    transform: "translate(-392.951 -462.49)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5829",
    "data-name": "Trazado 5829",
    d: "M393.66,388.584l-2.181.61-.61,8.207s.786,2.181,0,2.878-.959,15.612-.959,15.612a5.7,5.7,0,0,0,5.495.427s-.436-1.657.871-7.675a48.346,48.346,0,0,0,1.309-9.07s0-7.5.61-8.723,0-4.273,0-4.273-1.221-1.657-1.133-2.267S393.66,388.584,393.66,388.584Z",
    transform: "translate(-389.196 -350.55)",
    fill: "#4eb0b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5830",
    "data-name": "Trazado 5830",
    d: "M497.609,411.15s-1.133,9.768-4.449,11.6C493.16,422.751,500.573,420.658,497.609,411.15Z",
    transform: "translate(-470.818 -371.808)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5831",
    "data-name": "Trazado 5831",
    d: "M434.88,415.32s4.1,2,3.142,3.4S434.88,415.32,434.88,415.32Z",
    transform: "translate(-424.746 -375.105)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5832",
    "data-name": "Trazado 5832",
    d: "M434.88,434.47s2.616,2.7,2.095,3.664S434.88,434.47,434.88,434.47Z",
    transform: "translate(-424.746 -390.243)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5833",
    "data-name": "Trazado 5833",
    d: "M535.63,327.47a9.27,9.27,0,0,1,1.125,2.878C536.853,331.484,535.63,327.47,535.63,327.47Z",
    transform: "translate(-504.391 -305.657)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5834",
    "data-name": "Trazado 5834",
    d: "M535.63,315.5s.515-.438,1.831,0S535.63,315.5,535.63,315.5Z",
    transform: "translate(-504.391 -296.037)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5835",
    "data-name": "Trazado 5835",
    d: "M482.91,552.544a12.129,12.129,0,0,1-6.379-.817l-1.1,2.815-.121-1.3c.18-1.093.53-2.264,1.221-2.56A10.586,10.586,0,0,0,482.91,552.544Z",
    transform: "translate(-456.707 -482.11)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5836",
    "data-name": "Trazado 5836",
    d: "M426.18,577.07s5.365,1.112,6.869.915Z",
    transform: "translate(-417.868 -502.972)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5837",
    "data-name": "Trazado 5837",
    d: "M428.84,583.747a11.082,11.082,0,0,1,3.433.36Z",
    transform: "translate(-419.971 -508.243)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5838",
    "data-name": "Trazado 5838",
    d: "M430.09,588.31a20.522,20.522,0,0,0,3.171.419Z",
    transform: "translate(-420.959 -511.858)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5839",
    "data-name": "Trazado 5839",
    d: "M429.46,643.229c.1-.065,4.579-1.112,5.136-.36Z",
    transform: "translate(-420.461 -554.774)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5840",
    "data-name": "Trazado 5840",
    d: "M429.46,651.4s3.892-.459,3.99,0S429.46,651.4,429.46,651.4Z",
    transform: "translate(-420.461 -561.571)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5841",
    "data-name": "Trazado 5841",
    d: "M429.46,655.525s4.154-.859,4.644-.649S429.46,655.525,429.46,655.525Z",
    transform: "translate(-420.461 -564.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5842",
    "data-name": "Trazado 5842",
    d: "M412.629,791.406l-4.709,3.239s.027-.379.073-.936a12.693,12.693,0,0,1,2.411-3.936,1.93,1.93,0,0,1,2.149.48C412.57,790.947,412.629,791.406,412.629,791.406Z",
    transform: "translate(-403.433 -671.029)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5843",
    "data-name": "Trazado 5843",
    d: "M405.524,794.8a11.687,11.687,0,0,0-.982,4.818,7.472,7.472,0,0,1-1,3.877,3.83,3.83,0,0,1-.331.473s-3.272-.027-4.418-.976a1.133,1.133,0,0,1-.308-.377c-.656-1.307,1.276-6.311,1.276-6.311a13.9,13.9,0,0,1,3.073-5.92C406.5,789.436,405.524,794.8,405.524,794.8Z",
    transform: "translate(-395.869 -671.515)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5844",
    "data-name": "Trazado 5844",
    d: "M405.219,826.338a3.815,3.815,0,0,1-.331.473s-3.272-.027-4.418-.976c.563-1.864,2.361-7.505,3.2-6.546C404.465,820.19,405.016,824.524,405.219,826.338Z",
    transform: "translate(-397.544 -694.367)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5845",
    "data-name": "Trazado 5845",
    d: "M420.138,819.631l-.228,8.45h1.1s.178-7.413.668-8.45S420.138,819.631,420.138,819.631Z",
    transform: "translate(-412.911 -694.359)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5846",
    "data-name": "Trazado 5846",
    d: "M469.715,802.293s-4.807-4.546-4.317-4.906a2.227,2.227,0,0,0,.381-1c.924-.161,2.514.224,3.829,3.915C469.639,801.35,469.715,802.293,469.715,802.293Z",
    transform: "translate(-448.843 -676.325)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5847",
    "data-name": "Trazado 5847",
    d: "M465.791,807.865a.489.489,0,0,1-.115.034,34.132,34.132,0,0,1-3.817,0,.825.825,0,0,1-.8-.823c0-.314,0-.7-.025-1.106-.054-1.29-.209-2.826-.672-3.171-.819-.628-1.466-2.761,0-5.461,0,0,2.811-2.147,4.839,4.307a4.288,4.288,0,0,0,1.079,2.495C467.163,804.792,466.185,807.678,465.791,807.865Z",
    transform: "translate(-444.2 -676.828)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5848",
    "data-name": "Trazado 5848",
    d: "M471.49,828.411a34.148,34.148,0,0,1-3.817,0,.825.825,0,0,1-.8-.823c0-.314,0-.7-.025-1.106.354-1.563.863-3.171,1.519-3.538C468.373,822.942,470.357,822.718,471.49,828.411Z",
    transform: "translate(-450.019 -697.341)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5849",
    "data-name": "Trazado 5849",
    d: "M423.46,798.319l.528,7.032h.67V797.72Z",
    transform: "translate(-406.941 -672.907)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5850",
    "data-name": "Trazado 5850",
    d: "M428.136,239.08a12.028,12.028,0,0,0-5.367,1.724,2.23,2.23,0,0,0-1.012,1.016,3.368,3.368,0,0,0-.082,1.257c.057,3.607-3.965,6.337-3.84,9.942.05,1.431.769,2.763.9,4.189.22,2.38-1.188,4.569-2.537,6.54a5.417,5.417,0,0,0,3.823-1.267,28.99,28.99,0,0,1,.534,14.611h1.929a1.467,1.467,0,0,1,.563.069,1.417,1.417,0,0,1,.446.333c1.8,1.8,3.012,4.449,2.323,6.9l4.106-1.54a12.2,12.2,0,0,0,2.834-1.351,4.093,4.093,0,0,0,1.751-2.524c.111-.628.075-1.378.593-1.743a3.227,3.227,0,0,1,.809-.3c1.127-.4,1.625-1.7,1.856-2.874a16.552,16.552,0,0,0,.262-4.372c-.182-2.451-.907-4.939-.31-7.332.337-1.343,1.087-2.593,1.148-3.98.1-2.285-1.688-4.254-1.954-6.527-.186-1.584.385-3.186.2-4.77a5.124,5.124,0,0,0-2.7-3.89c-.5-.26-1.047-.434-1.546-.721-1.137-.66-1.864-1.848-2.9-2.665s-2.753-1.125-3.53-.063Z",
    transform: "translate(-409.979 -235.77)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5851",
    "data-name": "Trazado 5851",
    d: "M428.136,237.814a12.028,12.028,0,0,0-5.367,1.724,2.23,2.23,0,0,0-1.012,1.016,3.368,3.368,0,0,0-.082,1.257c.057,3.607-3.965,6.337-3.84,9.944.05,1.429.769,2.761.9,4.189.22,2.38-1.188,4.569-2.537,6.542a5.446,5.446,0,0,0,3.823-1.267,28.978,28.978,0,0,1,.534,14.607h1.929a1.467,1.467,0,0,1,.563.071,1.378,1.378,0,0,1,.446.331c1.8,1.8,3.012,4.449,2.323,6.9l4.106-1.54a12.2,12.2,0,0,0,2.834-1.351,4.093,4.093,0,0,0,1.751-2.524c.111-.628.075-1.378.593-1.743a3.227,3.227,0,0,1,.809-.3c1.127-.4,1.625-1.7,1.856-2.874a16.552,16.552,0,0,0,.268-4.376c-.182-2.451-.907-4.939-.31-7.332.337-1.343,1.087-2.593,1.148-3.98.1-2.285-1.688-4.254-1.954-6.527-.186-1.584.385-3.184.2-4.77a5.128,5.128,0,0,0-2.7-3.89c-.5-.26-1.047-.434-1.546-.718-1.137-.662-1.864-1.85-2.9-2.667s-2.752-1.125-3.53-.063Z",
    transform: "translate(-409.979 -234.766)",
    fill: "#925978"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8390",
    "data-name": "Grupo 8390",
    transform: "translate(6.221 6.174)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5852",
    "data-name": "Trazado 5852",
    d: "M442.273,252.81a2.325,2.325,0,0,0-.013.243C442.266,252.973,442.271,252.892,442.273,252.81Z",
    transform: "translate(-436.801 -252.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5853",
    "data-name": "Trazado 5853",
    d: "M514.932,280.271a22.29,22.29,0,0,0,.23-3.331A24.115,24.115,0,0,0,514.932,280.271Z",
    transform: "translate(-494.236 -271.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5854",
    "data-name": "Trazado 5854",
    d: "M424.9,304.81c-.121-1.3-.727-2.514-.869-3.81a4.77,4.77,0,0,0-.031.716c.05,1.414.752,2.736.894,4.143A5.658,5.658,0,0,0,424.9,304.81Z",
    transform: "translate(-422.365 -290.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5855",
    "data-name": "Trazado 5855",
    d: "M518.137,330.136a8.979,8.979,0,0,0-.209,2.6,7.879,7.879,0,0,1,.209-1.51c.337-1.343,1.087-2.593,1.148-3.98a4.322,4.322,0,0,0-.034-.737A34.756,34.756,0,0,1,518.137,330.136Z",
    transform: "translate(-496.603 -311.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5856",
    "data-name": "Trazado 5856",
    d: "M420.023,344.36a5.446,5.446,0,0,1-3.092,1.257c-.239.373-.486.737-.731,1.1a5.446,5.446,0,0,0,3.823-1.267,28.908,28.908,0,0,1,1.219,7.845A28.973,28.973,0,0,0,420.023,344.36Z",
    transform: "translate(-416.2 -325.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5857",
    "data-name": "Trazado 5857",
    d: "M474.1,389.737c-.23,1.173-.729,2.476-1.856,2.872a3.144,3.144,0,0,0-.809.3c-.517.364-.482,1.119-.593,1.743a4.041,4.041,0,0,1-1.751,2.514,12.593,12.593,0,0,1-2.834,1.353l-3.917,1.466a5.406,5.406,0,0,1-.189,1.163l4.106-1.54a12.2,12.2,0,0,0,2.834-1.351,4.093,4.093,0,0,0,1.751-2.524c.111-.628.075-1.378.593-1.743a3.23,3.23,0,0,1,.809-.3c1.127-.4,1.626-1.7,1.856-2.874a16.428,16.428,0,0,0,.3-3.708A16.4,16.4,0,0,1,474.1,389.737Z",
    transform: "translate(-452.525 -358.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5858",
    "data-name": "Trazado 5858",
    d: "M440,414.462a1.385,1.385,0,0,0-.446-.333,1.5,1.5,0,0,0-.563-.071h-1.711c-.067.364-.138.729-.209,1.091H439a1.466,1.466,0,0,1,.564.071,1.378,1.378,0,0,1,.446.331,8.3,8.3,0,0,1,2.491,4.906A7.814,7.814,0,0,0,440,414.462Z",
    transform: "translate(-432.698 -380.278)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5859",
    "data-name": "Trazado 5859",
    d: "M405.37,448.984s1.559-.654,1.906,0S405.37,448.984,405.37,448.984Z",
    transform: "translate(-401.417 -401.487)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5860",
    "data-name": "Trazado 5860",
    d: "M408,454.334s1.558-.654,1.908,0S408,454.334,408,454.334Z",
    transform: "translate(-403.496 -405.717)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "leaves",
    transform: "translate(150.282 1.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5861",
    "data-name": "Trazado 5861",
    d: "M842.289,51.641s-7.971-.48-7.03,5.1a1.362,1.362,0,0,0,.708,1.435s.015-.419.817-.274a3.668,3.668,0,0,0,.865.042,1.8,1.8,0,0,0,1.056-.438h0s2.239-.924,3.111-4.585c0,0,.645-.8.628-1.005L841.1,52.5a2.41,2.41,0,0,1,.1,1.776s-.042-1.743-.3-1.7c-.052,0-.7.335-.7.335a3.98,3.98,0,0,1,.193,2.92s.226-2.082-.44-2.8l-.951.563a4.179,4.179,0,0,1,.3,3.169s.161-2.185-.5-3.035l-.859.668a4.08,4.08,0,0,1,.346,2.893s-.069-2.545-.526-2.736a5.183,5.183,0,0,0-.863.934s.593,1.257.224,1.906c0,0-.226-1.693-.419-1.7a5.639,5.639,0,0,0-.825,1.885,4.086,4.086,0,0,1,.643-2,2.235,2.235,0,0,0-1.144.595s.115-.794,1.328-.865a5.223,5.223,0,0,1,.783-.9,4.912,4.912,0,0,0-1.938.224,2.189,2.189,0,0,1,2.16-.419l.838-.691a7.228,7.228,0,0,0-2.262.023,2.754,2.754,0,0,1,2.491-.18l.922-.551a8.276,8.276,0,0,0-2.16-.186,3.313,3.313,0,0,1,2.43.038l.66-.3s-.993-.195-1.282-.226-.306-.111-.306-.111a3.427,3.427,0,0,1,1.862.209A8.466,8.466,0,0,0,842.289,51.641Z",
    transform: "translate(-819.3 -47.112)",
    fill: "#006384",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5862",
    "data-name": "Trazado 5862",
    d: "M799.987,30.06s-6.7,4.338-2.637,8.278a1.363,1.363,0,0,0,1.42.737s-.235-.344.5-.706a3.635,3.635,0,0,0,.723-.48,1.8,1.8,0,0,0,.593-.978h0s1.257-2.074-.21-5.538c0,0,.046-1.026-.1-1.177l-.741,1.257a2.411,2.411,0,0,1,1.131,1.372s-1.066-1.376-1.257-1.19c-.038.038-.365.685-.365.685a3.965,3.965,0,0,1,1.885,2.235s-1.047-1.812-2.013-1.99l-.436,1.005a4.181,4.181,0,0,1,2.12,2.378s-1.167-1.856-2.2-2.151l-.293,1.047s1.718.871,1.992,2.137c0,0-1.563-2.007-2.045-1.885a5.3,5.3,0,0,0-.142,1.257s1.219.654,1.311,1.4c0,0-1.186-1.23-1.339-1.127a5.65,5.65,0,0,0,.454,2.013,4.092,4.092,0,0,1-.666-1.992,2.242,2.242,0,0,0-.57,1.156s-.377-.708.559-1.483a5.736,5.736,0,0,1,.094-1.192,4.849,4.849,0,0,0-1.429,1.328s.075-.985,1.5-1.609l.272-1.058a6.989,6.989,0,0,0-1.808,1.359s.232-.993,1.9-1.621l.419-.991a8.526,8.526,0,0,0-1.852,1.131,3.332,3.332,0,0,1,1.982-1.41l.356-.628s-.915.432-1.167.578-.312.092-.312.092a3.433,3.433,0,0,1,1.623-.936A8.333,8.333,0,0,0,799.987,30.06Z",
    transform: "translate(-788.357 -30.06)",
    fill: "#006384",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5863",
    "data-name": "Trazado 5863",
    d: "M760.791,54.119s-4.007,6.913,1.4,8.574a1.351,1.351,0,0,0,1.6,0s-.362-.2.124-.853a3.668,3.668,0,0,0,.419-.754,1.81,1.81,0,0,0,.086-1.142h0s.178-2.417-2.7-4.841c0,0-.419-.934-.628-1L761,55.566a2.415,2.415,0,0,1,1.632.71s-1.575-.744-1.655-.494c-.017.05-.015.775-.015.775a4.049,4.049,0,0,1,2.721,1.142s-1.76-1.137-2.7-.861l.067,1.093a4.177,4.177,0,0,1,2.966,1.158s-1.885-1.125-2.933-.92l.21,1.066a4.1,4.1,0,0,1,2.744,1s-2.3-1.081-2.679-.76a5.176,5.176,0,0,0,.446,1.192s1.383.029,1.806.656c0,0-1.615-.559-1.705-.4a5.647,5.647,0,0,0,1.32,1.586,4.091,4.091,0,0,1-1.5-1.466,2.245,2.245,0,0,0,.017,1.288s-.658-.459-.176-1.575a5.264,5.264,0,0,1-.455-1.1,4.978,4.978,0,0,0-.67,1.831,2.171,2.171,0,0,1,.6-2.111l-.237-1.068a7,7,0,0,0-.995,2.032,2.75,2.75,0,0,1,.957-2.3l-.08-1.07a8.363,8.363,0,0,0-1.135,1.848,3.305,3.305,0,0,1,1.125-2.155l.031-.723s-.628.8-.777,1.047-.237.214-.237.214a3.448,3.448,0,0,1,1.022-1.573A8.535,8.535,0,0,0,760.791,54.119Z",
    transform: "translate(-759.362 -49.064)",
    fill: "#006384",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5864",
    "data-name": "Trazado 5864",
    d: "M897.354,341.6a3,3,0,1,0,3,3A3,3,0,0,0,897.354,341.6ZM888.59,318.08v3h3l5.4,10.93-2.256,3.672a2.881,2.881,0,0,0-.375,1.424c0,2.007,1.372,3,3.232,3h17.527V337.22h-17.16a.354.354,0,0,1-.375-.375,1.882,1.882,0,0,1,.159-.373l1.5-2.365H910.4a2.933,2.933,0,0,0,2.623-1.573l5.4-9.282a1.741,1.741,0,0,0,.151-.75,1.441,1.441,0,0,0-1.5-1.424H894.887l-1.424-3ZM912.112,341.6a3,3,0,1,0,3,3A3,3,0,0,0,912.112,341.6Z",
    transform: "translate(-711.238 -255.961)",
    fill: "#04cd9e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutIcon);
export default __webpack_public_path__ + "static/media/checkout-icon.fd5c2ceb38062a2c73494bf9cee3ce87.svg";
export { ForwardRef as ReactComponent };